<template>
  <div class="center-top-list">
    <div class="top-total flex justify">
      <div class="total-data">
        <img :src="require('@/assets/daping/data-bg.png')" class="data-bg" />
        <div>
          <span class="top-num">
            今日累计上报问题数
            <span class="only-num">{{
              addThousandsSeparator(this.numberTodaylist.value)
            }}</span
            >个
          </span>
        </div>
      </div>
      <div class="total-data">
        <img :src="require('@/assets/daping/data-bg.png')" class="data-bg" />
        <div>
          <span class="top-num">
            今日已巡查孤寡老人
            <span class="only-num">{{ addThousandsSeparator(this.livingAloneList.value) }}</span
            >个
          </span>
        </div>
      </div>
    </div>
    <div class="report-summary flex justify-between">
      <div v-for="(item, index) in summaryData" :key="index" class="list">
        <img :src="item.img" />
        <div class="list-data">
          <div class="progress-data">
            {{ item.autoComputedRate }}<span style="font-size: 24px"> % </span>
          </div>
          <div class="name">
            {{ item.name }}
          </div>
          <div class="beInspected">
            待巡查 <span>{{ item.value }}项</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mapTop from "./components/mapTop.vue";
import bottom from "./bottom.vue";
import { extendBigScreenMapTj } from "@/api/daping.js";
export default {
  name: "index",
  components: {},
  data() {
    return {
      pointInfo: {},
      summaryData: [
        {
          name: "长期巡查任务",
          value: "0",
          autoComputedRate: 0,
          img: require("@/assets/daping/cqxcrw.svg"),
        },
        {
          name: "孤寡老人巡查",
          value: "0",
          autoComputedRate: 0,
          img: require("@/assets/daping/gglrxc.svg"),
        },
        {
          name: "上报问题处置率",
          value: "0",
          autoComputedRate: 0,
          img: require("@/assets/daping/sbwtczl.svg"),
        },
      ],
      numberTodaylist: {},
      livingAloneList: {},
      mapListData: {}
    };
  },
  mounted() {
    this.extendBigScreenMapTj();
  },
  methods: {
    async extendBigScreenMapTj() {
      let res = await extendBigScreenMapTj();
      if (res.data.code == 200) {
        let data = res.data.data && res.data.data.someCountList;
        this.numberTodaylist = data.find((item) => item.label === "今日累计上报问题数");
        this.livingAloneList = data.find((item) => item.label === "今日已巡查孤寡老人");
        this.summaryData.forEach((item) => {
          data.forEach((itemData) => {
            if (item.name == itemData.label) {
              item.value = Number(itemData.value);
              item.autoComputedRate = itemData.autoComputedRate;
            }
          });
        });
      }
    },
    addThousandsSeparator(number) {
      return number && number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style scoped lang="less">
.center-map {
  flex: 1;
}
.flex {
  display: flex;
}
.justify {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.center-top-list {
  position: relative;
  z-index: 999;
  .top-total {
    .total-data {
      position: relative;
      height: 63px;
    }
    .total-data:first-child {
      margin-right: 62px;
    }
    .data-bg {
      width: 313px;
      height: 63px;
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translateX(-50%);
    }
    .top-num {
      font-family: MiSans, MiSans;
      font-weight: 600;
      font-size: 24px;
      color: #f3f8ff;
      line-height: 32px;
      text-align: left;
      font-style: normal;
      background: linear-gradient(180deg, #fff 0%, #5bacef 100%);
      color: transparent;
      -webkit-background-clip: text;
      background-clip: text;
      text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
      .only-num {
        font-family: MiSans Medium;
        font-weight: 500;
        font-size: 48px;
        color: #00ceff;
        margin: 0 12px;
      }
    }
  }
  .report-summary {
    margin: 42px 130px;
    .list {
      position: relative;
      img {
        width: 414px;
        height: 160px;
      }
      .list-data {
        position: absolute;
        top: 10px;
        left: 200px;
        font-family: MiSans, MiSans;
        font-weight: 500;
        .progress-data {
          font-size: 48px;
          color: #00ceff;
        }
        .name {
          font-size: 28px;
          color: #e4f2ff;
          line-height: 37px;
          text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
        }
        .beInspected {
          font-size: 16px;
          color: #adc2d3;
          line-height: 26px;
          margin-top: 4px;
          text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreen/components/centerItem/center-top.vue